module.exports = __webpack_public_path__ + "static/media/pie-chart-analytics-svgrepo-com.1567c481.svg";